export default {
  'nav.poti': 'Trails',
  'nav.izhodisca': 'Starting Points',
  'nav.galerija': 'Gallery',
  'nav.vreme': 'Weather',
  'nav.o_nas': 'About Us',
  'nav.zacni_pot': 'Start the Trail',
  'nav.odpri_meni': 'Open menu',
  'nav.zapri_meni': 'Close menu',
  'nav.preskoci': 'Skip to content',

  'hero.badge': 'STEZA Tourist Association — Šmarna Gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'One of the most beautiful, varied and welcoming trails for visitors of all generations.',
  'hero.cta_start': 'Start the Trail',
  'hero.cta_explore': 'Explore Trails',
  'hero.cta_activities': 'Activities',
  'hero.scroll': 'Scroll down',

  'intro.badge': 'Welcome',
  'intro.title': 'Šmarna Gora, Ljubljana\'s most beloved hill',
  'intro.desc': 'Šmarna Gora, the most popular hill near Ljubljana, offers numerous trails for hikers, runners and nature lovers.',
  'intro.highlight': 'The Peske Trail is considered one of the most beautiful, varied and welcoming paths for visitors of all ages.',
  'intro.pot_label': 'Peske Trail',
  'intro.route': 'Spodnje Pirniče → Šmarna Gora',

  'activities.badge': 'Activities',
  'activities.title': 'EXPLORING ŠMARNA GORA',
  'activities.hiking.title': 'Hiking to Šmarna Gora',
  'activities.hiking.desc': 'Discover various trails, from easy walks to more challenging ascents.',
  'activities.cycling.title': 'Cycling around Šmarna Gora',
  'activities.cycling.desc': 'Explore scenic cycling routes in the surrounding area with beautiful views.',
  'activities.running.title': 'Trail Running on Šmarna Gora',
  'activities.running.desc': 'A popular destination for trail runners — varied terrain with an ideal gradient.',
  'activities.running_around.title': 'Running around Šmarna Gora',
  'activities.running_around.desc': 'Flat and gentle running loops at the base, perfect for recreational training.',
  'activities.walks.title': 'Walks beneath Šmarna Gora',
  'activities.walks.desc': 'Peaceful walks through meadows and forest paths, ideal for families.',

  'access.badge': 'Starting Point',
  'access.title': 'STARTING POINT & ACCESS',
  'access.desc': 'The trail begins at the LIPA car park in Spodnje Pirniče. Access is straightforward — by car or bus.',
  'access.start_label': 'Trail Starting Point',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'LIPA Car Park',
  'access.parking': 'Car Park',
  'access.free': 'Free',
  'access.bus': 'Bus',
  'access.bus_line': 'Line 25',
  'access.info1': 'Park your vehicle at the LIPA car park or arrive by bus number 25 directly to the starting point in front of the restaurant with a beautiful terrace, where you can enjoy a refreshing drink or snack before beginning your hike.',
  'access.info2': 'At the start, a narrow path covered with wood chips leads you past a meadow towards the forest, where the ascent begins.',

  // ── PARKING ──
  'parking.hero_title': 'LIPA Parking — Official Trailhead',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno. Free parking right at the start of the Pot na Peske trail.',
  'parking.highlight_badge': '⭐ Official Trailhead',
  'parking.section_title': 'PARKING & ACCESS',
  'parking.intro': 'LIPA parking is the official, free, and most convenient trailhead for Pot na Peske — our most beautiful trail to Šmarna gora.',
  'parking.address_label': 'Address',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno, Slovenia',
  'parking.gps_label': 'GPS Coordinates',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Capacity',
  'parking.capacity_value': 'Free, space for 20+ vehicles',
  'parking.type_label': 'Parking Type',
  'parking.type_value': 'Open gravel parking lot',
  'parking.hours_label': 'Open',
  'parking.hours_value': '24/7 — all year round',
  'parking.bus_info_title': 'Public Transport',
  'parking.bus_info': 'LPP bus line 25 goes directly to the stop right in front of the parking lot. The ride from Ljubljana city center takes about 30 minutes.',
  'parking.facilities_title': 'Amenities',
  'parking.facility_gostilna': 'Restaurant with a beautiful terrace right next to the parking lot',
  'parking.facility_wc': 'WC available at the restaurant',
  'parking.facility_info': 'Trail information board at the start of Pot na Peske',
  'parking.facility_sign': 'STEZA / Pot na Peske directional sign',
  'parking.tips_title': 'Parking Tips',
  'parking.tip1': 'On weekends and holidays, the parking lot fills up quickly — arrive early (before 8 AM) to secure a spot.',
  'parking.tip2': 'The parking lot is gravel — in winter, watch out for possible ice on the parking surface.',
  'parking.tip3': 'Do not leave valuables in your car. Park at your own risk.',
  'parking.tip4': 'Additional parking is available at Gostilna Ledinek in Tacen (5 min drive) if LIPA is full.',
  'parking.map_title': 'Location on Map',
  'parking.cta_title': 'Ready for Pot na Peske?',
  'parking.cta_subtitle': 'Park at LIPA and embark on the most beautiful trail to Šmarna gora.',
  'parking.cta_btn': 'Start the Trail',
  'parking.cta_routes': 'All Trails',

  'story.badge': 'Peske Trail',
  'story.title': 'FROM TRAILHEAD TO SUMMIT',
  'story.subtitle': 'A cinematic journey through every stage of the trail',
  'story.etapa': 'Stage',
  'story.blocks.0.title': 'Gentle Beginning',
  'story.blocks.0.text': 'We start with a gentle climb on a comfortable, wide path partially covered with rocks and roots. Soon we turn onto an increasingly narrower trail that rises somewhat more steeply.',
  'story.blocks.0.terrain': 'Wide path, rocks, roots',
  'story.blocks.1.title': 'Most Dynamic Section',
  'story.blocks.1.text': 'We walk over increasingly sandy ground, across rocks and roots, partly through a relatively deep gully. This is the steepest but also the most varied part of the trail.',
  'story.blocks.1.terrain': 'Sandy ground, rocks, gully',
  'story.blocks.2.title': 'Gravel Road',
  'story.blocks.2.text': 'As the path widens and flattens, we soon reach a wide gravel road — the vehicle route to Šmarna Gora coming from Zavrh.',
  'story.blocks.2.terrain': 'Gravel, wide path',
  'story.blocks.3.title': 'Turkish Monument',
  'story.blocks.3.text': 'Here a trail sign directs us right, past the Plague or Turkish Monument, which recalls the times of Ottoman invasions.',
  'story.blocks.3.terrain': 'Trail signpost, historical point',
  'story.blocks.4.title': 'Gorjanc Chapel',
  'story.blocks.4.text': 'The road climbs gently through the forest, which gradually opens up. On the left is the Gorjanc Chapel, where the custom of placing small crosses is preserved.',
  'story.blocks.4.terrain': 'Forest road, chapel',
  'story.blocks.5.title': 'Spodnji Gorjanc — Junction',
  'story.blocks.5.text': 'We arrive at Spodnji Gorjanc, an important trail junction. Here, paths intersect towards Grmada, the Roots Trail (towards Tacen) and the continuation to Šmarna Gora.',
  'story.blocks.5.terrain': 'Trail junction, Grmada, Roots Trail',
  'story.blocks.6.title': 'Alpine Views',
  'story.blocks.6.text': 'We continue through grazing meadows, where views open up of the Kamnik-Savinja Alps and the Julian Alps with Triglav.',
  'story.blocks.6.terrain': 'Grazing meadows, panoramic views',
  'story.blocks.7.title': 'Sedlo — Grmada Crossing',
  'story.blocks.7.text': 'At Sedlo (Saddle), the trail intersects with the route to Grmada and joins paths from Tacen, Šmartno and Vikrče. From here, choose the easier gravel route or a narrower, rockier path past the St. Sobota Chapel.',
  'story.blocks.7.terrain': 'Saddle, Grmada-Šmarna Gora junction, two options',
  'story.blocks.8.title': 'Summit — Choose Your Path',
  'story.blocks.8.text': 'We recommend the steeper ascent and a gentler descent. This way you experience both sides of Šmarna Gora and enjoy the full experience.',
  'story.blocks.8.terrain': 'Two paths, ascent and descent',

  'highlight.title': 'One of the most welcoming trails on Šmarna Gora',
  'highlight.text1': 'This is also one of the most welcoming trails on Šmarna Gora — never exposed, without major steep sections, and pleasant to walk even after rain when many other trails are muddy.',
  'highlight.text2': 'The first section is highly varied and therefore extremely popular among hikers, runners and families.',

  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'VIEWS FROM THE SUMMIT',
  'viewpoint.desc': 'On the summit of Šmarna Gora, take time on clear days to enjoy magnificent views of Ljubljana, the Sava River, surrounding hills and the Alps. The peak with its picturesque church offers one of the finest panoramas in central Slovenia.',

  'gallery.badge': 'Gallery',
  'gallery.title': 'Šmarna Gora through the lens',
  'gallery.subtitle': 'Moments that bring the mountain spirit to life — every photograph tells its own story',
  'gallery.enlarge': 'Enlarge',
  'gallery.close': 'Close preview',
  'gallery.prev': 'Previous image',
  'gallery.next': 'Next image',
  'gallery.open': 'Open image',

  'weather.badge': 'Live Weather',
  'weather.title': 'WEATHER ON ŠMARNA GORA',
  'weather.loading': 'Refreshing...',
  'weather.updated': 'Last updated',
  'weather.current': 'Current',
  'weather.feels_like': 'Feels like',
  'weather.wind': 'Wind',
  'weather.humidity': 'Humidity',
  'weather.visibility': 'Visibility',
  'weather.cloud_cover': 'Cloud Cover',
  'weather.uv_index': 'UV Index',
  'weather.rain': 'Rain',
  'weather.hiking_score': 'Hiking Score',
  'weather.out_of': 'out of 100 points',
  'weather.trail_safety': 'Trail Safety',
  'weather.safety_optimal': 'Safe Conditions',
  'weather.safety_caution': 'Caution Needed',
  'weather.safety_warning': 'Difficult Conditions',
  'weather.safety_danger': 'Dangerous Conditions',
  'weather.no_alerts': 'No special warnings',
  'weather.best_time': 'Best Time to Hike',
  'weather.next_hours': 'Next Hours',
  'weather.seven_day': '7-Day Forecast',
  'weather.disclaimer': 'Data is for informational purposes only. Always check the official weather forecast before hiking. Source: Open-Meteo API.',
  'weather.error_load': 'Weather data could not be loaded',
  'weather.error_stale': 'Showing last cached data',
  'weather.smarna_elevation': 'Šmarna Gora, 669m',

  'safety.badge': 'Important',
  'safety.title': 'TRAIL SAFETY',
  'safety.slippery_title': 'Slippery Surface',
  'safety.slippery_desc': 'After rain, roots and rocks become extremely slippery. Wear hiking boots with good grip. Avoid shortcuts across wet terrain.',
  'safety.winter_title': 'Winter Conditions',
  'safety.winter_desc': 'In winter, trails can be icy. Winter equipment is essential: crampons, hiking poles. Check the weather before departure.',
  'safety.sunset_title': 'Sunrise / Sunset',
  'safety.sunset_desc': 'If heading out for sunrise or sunset, always bring a headlamp. Always tell someone your destination.',
  'safety.emergency_title': 'Emergency',
  'safety.emergency_desc': 'In an emergency, call 112. The Mountain Rescue Service app enables quick location sharing. Save the number before your hike.',
  'safety.warning_title': 'WARNING',
  'safety.warning_text': 'The information on this page is for informational purposes only. Hiking is undertaken at your own risk. Before every hike, check weather conditions, ensure appropriate equipment, and assess your physical fitness. STEZA assumes no liability for potential injuries or accidents.',

  'facebook.badge': 'Community',
  'facebook.title': 'JOIN US',
  'facebook.desc': 'Follow STEZA.SI on Facebook for the latest news, events and photos',
  'facebook.label': 'Facebook Community',

  'webcam.badge': 'Live',
  'webcam.title': 'ŠMARNA GORA WEBCAM',
  'webcam.desc': 'Live view from the summit of Šmarna Gora — coming soon',
  'webcam.coming_soon': 'Webcam coming soon',
  'webcam.preparing': 'We are preparing a live feed from the summit of Šmarna Gora. Thank you for your patience.',
  'webcam.status': 'In preparation',

  'media.badge': 'Media',
  'media.title': 'GALLERY & VIDEO',
  'media.desc': 'Cinematic footage and photography of Šmarna Gora — coming soon',
  'media.drone': 'DRONE VIDEO IN PRODUCTION',
  'media.drone_desc': 'Cinematic footage of the Peske Trail',
  'media.views': 'Views',
  'media.trail': 'Trail',
  'media.history': 'History',

  'footer.desc': 'The Peske Trail — Šmarna Gora. STEZA Tourist Association. A premium hiking experience with professional trail, weather and safety information.',
  'footer.newsletter_title': 'Get Trail Updates',
  'footer.newsletter_success': 'Thank you! You are now subscribed to STEZA news.',
  'footer.newsletter_placeholder': 'Enter your email',
  'footer.newsletter_btn': 'Subscribe',
  'footer.trails': 'Trails',
  'footer.platform': 'Platform',
  'footer.legal': 'Legal',
  'footer.pot_peske': 'Peske Trail',
  'footer.pot_korenine': 'Roots Trail',
  'footer.mazijeva': 'Mazi Trail',
  'footer.romarska': 'Pilgrim Path',
  'footer.plezalna': 'Climbing Route',
  'footer.izhodisca': 'Starting Points',
  'footer.galerija': 'Gallery',
  'footer.vreme': 'Weather',
  'footer.o_stezi': 'About STEZA',
  'footer.kontakt': 'Contact',
  'footer.privacy': 'Privacy Policy',
  'footer.cookies': 'Cookies',
  'footer.disclaimer': 'Disclaimer',
  'footer.safety_notice': 'Safety Notice',
  'footer.copyright': '© 2026 STEZA.SI — STEZA Tourist Association, Šmarna Gora',
  'footer.disclaimer_text': 'Important notice: The information on this site is for informational purposes only. Hiking and outdoor activities are undertaken at your own risk. Check weather conditions, appropriate equipment and trail status before visiting.',
  'footer.facebook_label': 'STEZA on Facebook',
  'footer.instagram_label': 'STEZA on Instagram',

  'about.hero_title': 'About STEZA',
  'about.hero_subtitle': 'A premium hiking platform, created with love for Šmarna Gora.',
  'about.story_badge': 'Our Story',
  'about.story_title': 'The most beautiful trail on Šmarna Gora',
  'about.story_p1': 'STEZA was born from a simple idea: hiking Šmarna Gora can be more than just recreation — it can be an experience. We created a platform that combines professional hiking information with outstanding aesthetics and modern technology.',
  'about.story_p2': 'We are a team of hikers, photographers and designers who believe every mountain deserves its own premium presentation. Šmarna Gora is not just a hill — it is a symbol of Ljubljana, a pilgrimage destination, a natural gem and a sports arena all in one.',
  'about.story_p3': 'STEZA is not a tourist portal. It is not a blog. It is a premium cinematic hiking platform for everyone who wants to discover Šmarna Gora differently.',
  'about.elevation_label': 'Šmarna Gora',
  'about.elevation': '669 m a.s.l.',
  'about.how_title': 'How STEZA Was Created',
  'about.how_p1': 'The story began on the summit of Šmarna Gora. We stood on the viewing platform, looking towards the Alps and asked ourselves: why does such a beautiful hill not have a modern, clear and beautiful online presence? All we found were scattered forum posts, outdated blogs and low-quality photos. That is when we decided — we would create something different.',
  'about.how_p2': 'We spent the next six months in the field. We hiked every path — from the easiest to the most demanding. We photographed sunrises, rainy forests, snowy peaks and golden sunsets. We talked to local guides, innkeepers, seasoned hikers and first-time visitors. We wanted to understand Šmarna Gora from every angle.',
  'about.how_p3': 'STEZA is not just a website. It is a visual diary of our love for this mountain. Every photograph is professionally shot, every trail personally walked, every fact verified. We believe that Šmarna Gora — as one of the most visited hiking destinations in Slovenia — deserves a world-class presentation.',
  'about.how_p4': 'We drew design inspiration from premium outdoor brands like Patagonia, The North Face and National Geographic Travel. We wanted to create a platform that breathes adventure while remaining minimalist, clean and professional.',
  'about.how_p5': 'Today STEZA covers four main trails to Šmarna Gora, live weather data, GPS navigation, safety guidelines and a rich gallery. But this is just the beginning. Our vision is to become the finest hiking platform in Slovenia — and Šmarna Gora is our first, dearest project.',
  'about.gora_badge': 'Discover the Mountain',
  'about.gora_title': 'Šmarna Gora — the heart of our story',
  'about.gora_subtitle': '669 metres that connect generations',
  'about.gora_p1': 'Šmarna Gora (669 m) is the most popular hiking peak in central Slovenia. It lies just 10 kilometres northwest of Ljubljana, yet despite its proximity to the city, it offers genuine contact with nature, rich history and breathtaking views.',
  'about.gora_p2': 'It is an inselberg — a hill that geologically belongs to no larger mountain range, rising independently above the Ljubljana Basin. Composed of limestone and dolomite, its southern slopes are known for warmth-loving plant species.',
  'about.gora_p3': 'Over the centuries, Šmarna Gora has been everything: a prehistoric settlement, a strategic point with Šumberk Castle, a pilgrimage destination, a popular excursion spot for city dwellers, and today it is an indispensable part of Ljubljana\'s sporting and cultural identity.',
  'about.history_title': 'History Carved in Stone',
  'about.history_bronze_date': '1500 BC',
  'about.history_bronze_title': 'Bronze Age',
  'about.history_bronze_text': 'Archaeological finds on the summit testify to a prehistoric settlement. Pottery, tools and dwelling remains indicate permanent habitation during the Bronze Age.',
  'about.history_castle_date': '12th—13th c.',
  'about.history_castle_title': 'Šumberk Castle',
  'about.history_castle_text': 'The medieval Šumberk Castle (Schönberg) once stood on the summit. Today, only modest archaeological traces and legends of knights remain.',
  'about.history_church_date': '1711',
  'about.history_church_title': 'Church of the Mother of God',
  'about.history_church_text': 'A Baroque church was built on the site of an earlier Gothic church from the 14th century. It became the central pilgrimage destination of central Slovenia.',
  'about.history_modern_date': '19th c.—today',
  'about.history_modern_title': 'Alpine Destination',
  'about.history_modern_text': 'With the development of mountaineering, it became the most popular hiking destination for Ljubljana residents. It holds this status today with over 500,000 visitors annually.',
  'about.nature_title': 'Nature That Inspires',
  'about.nature_p1': 'The southern slopes of Šmarna Gora are a botanical paradise. The warm microclimate supports plants typically found much further south: black hellebore blooms as early as February, followed by fragrant iris, common pasque flower and autumn crocus.',
  'about.nature_p2': 'The forests are mixed — beech, oak and spruce dominate, with a magnificent chestnut tree at the summit. Wildlife includes deer, foxes, wild boar, badgers, squirrels and dormice.',
  'about.nature_p3': 'We promote responsible hiking — leave no trace, do not pick plants, do not disturb wildlife and take your rubbish back to the valley.',
  'about.legends_title': 'Legends That Live On',
  'about.legend_bell_title': 'The Wishing Bell',
  'about.legend_bell_text': 'The most famous legend of Šmarna Gora. If you ring the bell three times — first for health, second for luck and third for love — making a wish with each ring, your wish will come true.',
  'about.legend_castle_title': 'Šumberk Castle and the Treasure',
  'about.legend_castle_text': 'Legend says that the knights of Šumberk Castle buried a golden treasure somewhere on the slopes of Šmarna Gora before leaving for the Crusades. It has never been found.',
  'about.legend_mary_title': 'The Apparition of Mary',
  'about.legend_mary_text': 'According to folk tradition, the Virgin Mary appeared on the hilltop, giving the mountain its name. This tradition led to the construction of the church and a pilgrimage tradition lasting over 300 years.',
  'about.stats_title': 'STEZA in Numbers',
  'about.values_title': 'Our Values',
  'about.values.professionalism': 'Professionalism',
  'about.values.professionalism_text': 'All information is carefully verified and regularly updated. We collaborate with local guides and the Mountain Rescue Service.',
  'about.values.aesthetics': 'Aesthetics',
  'about.values.aesthetics_text': 'We believe beautiful visuals are key to inspiration. Every photograph on the site is professionally taken and curated.',
  'about.values.safety': 'Safety',
  'about.values.safety_text': 'Safety comes first. Every trail includes detailed warnings, recommended equipment and safety guidelines.',
  'about.values.passion': 'Passion',
  'about.values.passion_text': 'STEZA is a passion project. Every team member is a hiker who personally knows every trail on Šmarna Gora.',
  'about.values.sustainability': 'Sustainability',
  'about.values.sustainability_text': 'We promote responsible hiking. Leave no trace, respect nature and wildlife, take your rubbish with you.',
  'about.values.community': 'Community',
  'about.values.community_text': 'We are building a community of hikers who share experiences and help each other discover Šmarna Gora.',
  'about.cta_title': 'Join STEZA',
  'about.cta_subtitle': 'Every trail has a story. Discover it with us.',
  'about.cta_explore': 'Explore Trails',
  'about.cta_contact': 'Contact Us',

  'contact.hero_title': 'Contact',
  'contact.hero_subtitle': 'Have a question, suggestion or would you like to collaborate? Write to us or give us a call.',
  'contact.write_us': 'Write to Us',
  'contact.email_label': 'Email',
  'contact.phone_label': 'Phone',
  'contact.location_label': 'Location',
  'contact.location_value': 'Šmarna Gora, 1211 Ljubljana-Šmartno, Slovenia',
  'contact.follow_us': 'Follow Us',
  'contact.success_title': 'Thank you for your message!',
  'contact.success_text': 'We will get back to you as soon as possible.',
  'contact.name_label': 'Name',
  'contact.name_placeholder': 'Your name',
  'contact.email_placeholder': 'your@email.com',
  'contact.message_label': 'Message',
  'contact.message_placeholder': 'Your message (max 500 characters)',
  'contact.submit': 'Send Message',
  'contact.error_fields': 'Please fill in all fields.',
  'contact.error_length': 'Message too long. Maximum 500 characters.',
  'contact.error_general': 'An error occurred. Please try again.',

  'routes.hero_title': 'Trails',
  'routes.hero_subtitle': 'Five unique trails to the summit of Šmarna Gora. From the easy Peske Trail to demanding climbing routes — choose your STEZA.',
  'routes.explore': 'Explore Trail',
  'routes.compare_title': 'Trail Comparison',
  'routes.table_pot': 'Trail',
  'routes.table_tezavnost': 'Difficulty',
  'routes.table_trajanje': 'Duration',
  'routes.table_visinska': 'Elevation',
  'routes.table_dolzina': 'Length',
  'routes.table_tip': 'Type',
  'routes.cta_title': 'Ready for your STEZA?',
  'routes.cta_subtitle': 'Choose the trail that suits you best and discover Šmarna Gora in a way you will remember.',
  'routes.cta_find': 'Find Starting Point',
  'routes.cta_weather': 'Check Weather',
  'routes.difficulty_easy': 'Easy',
  'routes.difficulty_moderate': 'Moderate',
  'routes.difficulty_hard': 'Difficult',

  'gallery_page.badge': 'Photographic Collection',
  'gallery_page.title': 'Gallery',
  'gallery_page.subtitle': 'A collection of photographs from Šmarna Gora — trails, views and moments we share.',
  'gallery_page.section_trail_title': 'The Path to the Summit',
  'gallery_page.section_trail_subtitle': 'Hiking trails through forest and nature during the ascent',
  'gallery_page.section_summit_title': 'The Summit',
  'gallery_page.section_summit_subtitle': 'Views, panoramas and moments at the top of Šmarna Gora',
  'gallery_page.section_parking_title': 'Car Park',
  'gallery_page.section_parking_subtitle': 'Access to the trailhead and parking throughout all seasons',
  'gallery_page.empty_title': 'The {title} section is ready. Add images and they will appear here.',
  'gallery_page.empty_subtitle': 'Section is ready.',
  'gallery_page.close': 'Close gallery',
  'gallery_page.prev': 'Previous image',
  'gallery_page.next': 'Next image',
  'gallery_page.open': 'View image',
  'gallery_page.cta_title': 'Capture Your Own Photo',
  'gallery_page.cta_subtitle': 'The most beautiful photos are taken at the summit. Share your best shots with the hashtag #STEZA.',
  'gallery_page.cta_btn': 'Find Your Trail',

  'legal.not_found': 'Page not found',
  'legal.back_home': '← Back home',
  'legal.updated': 'Last updated',
  'legal.copyright': '© 2026 STEZA.SI — All rights reserved. Contact: info@steza.si',

  'notfound.title': 'This page has not been generated',
  'notfound.subtitle': 'Tell me more about this page, so I can generate it',
  'notfound.back_home': 'Back to homepage',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'The Peske Trail — Šmarna Gora | STEZA — Premium Hiking Platform',
  'seo.home_desc': 'The Peske Trail is one of the most beautiful routes to Šmarna Gora. A premium hiking experience with professional trail, weather, safety and viewpoint information. STEZA Tourist Association.',
  'seo.home_keywords': 'Peske Trail, Šmarna Gora, hiking Šmarna Gora, hiking Slovenia, Šmarna Gora trails, hiking Ljubljana, mountaineering Slovenia',
  'seo.og_title': 'The Peske Trail — Šmarna Gora | STEZA',
  'seo.og_desc': 'Premium hiking platform for Šmarna Gora. Discover the Peske Trail — one of the most beautiful and welcoming paths to Šmarna Gora.',
  'seo.schema_desc': 'The Peske Trail is one of the most beautiful routes to Šmarna Gora. STEZA Tourist Association — a premium hiking platform for Šmarna Gora.',
};